import { createContext, useContext } from "react";

const AIHighlightContext = createContext({
  highlightedFields: null,
});

export const AIHighlightProvider = AIHighlightContext.Provider;

export const useAIHighlight = (fieldKey) => {
  const { highlightedFields } = useContext(AIHighlightContext);
  return highlightedFields?.has(fieldKey) ?? false;
};
